import { CSSResultGroup, html, LitElement, nothing } from 'lit'
import { classMap } from 'lit/directives/class-map.js'
import { customElement, property } from 'lit/decorators.js'
import { buttonStyle } from './pagination.style.js'
import { CSEPaginationSection } from './pagination-section.js'
import { initializeIconsByRole } from '@cloudsuite/mosaic-shared/icons/library.js'
import { fontStyles } from 'elements/_shared/fonts.style.js'
import { hostStyle } from '@cloudsuite/mosaic-shared/styles/host.style.js'


initializeIconsByRole({
  'cse-pagination-button.previous': { name: 'angle-left', style: 'regular' },
  'cse-pagination-button.next': { name: 'angle-right', style: 'regular' },
})

@customElement('cse-pagination-button')
export class CSEPaginationButton extends LitElement {
  static override styles: CSSResultGroup = [fontStyles, hostStyle, buttonStyle]

  @property()
  url = ''

  @property({ type: Boolean })
  previous = false

  @property({ type: Boolean })
  next = false

  @property({ type: Boolean })
  active = false

  @property({ type: Boolean })
  disabled = false

  private renderIcon = (shouldRender: boolean, role: string) => {
    if (shouldRender) {
      return html`<cse-icon icon-role="cse-pagination-button.${role}"></cse-icon>`
    }
    return nothing
  }

  private renderButtonContents = () => html`
    ${this.renderIcon(this.previous, 'previous')}
    <slot></slot>
    ${this.renderIcon(this.next, 'next')}
  `

  override render() {
    const classes = classMap({
      'cse-pagination-button': true,
      'active': this.active,
      'disabled': this.disabled,
      'navigation': this.previous || this.next,
      'font-body-s': this.previous || this.next,
      'font-body': !this.previous && !this.next,
    })

    if (this.url) {
      return html`
        <a href="${this.url}" role="link" class=${classes}>
          ${this.renderButtonContents()}
        </a>
      `
    }

    return html`
      <button class=${classes}>
        ${this.renderButtonContents()}
      </button>
    `
  }
}


export const paginationAlignments = ['start', 'end', 'center'] as const
export type paginationAlignmentsType = typeof paginationAlignments


declare global {
  interface HTMLElementTagNameMap {
    'cse-pagination': CSEPaginationSection,
    'cse-pagination-button': CSEPaginationButton
  }
}
